import { render } from "./outletSkeleton.vue?vue&type=template&id=3d506b4a&scoped=true"
import script from "./outletSkeleton.vue?vue&type=script&lang=js"
export * from "./outletSkeleton.vue?vue&type=script&lang=js"

import "./outletSkeleton.vue?vue&type=style&index=0&id=3d506b4a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3d506b4a"]])

export default __exports__